









import {Vue, Component, Model, Prop} from 'vue-property-decorator';
@Component
export default class BasicRadioButton extends Vue {
  @Prop({required: true}) private radioOptions!: any;

  @Model('change', {type: String}) readonly value!: number | string;
  private valueChanged(e: Event) {
    const changedValue = (e.target as HTMLInputElement).value;
    this.$emit('change', changedValue);
  }
}
